module.exports = __webpack_public_path__ + "img/vn_vn.bdbf493e.png";